import { Pipe, PipeTransform } from '@angular/core';
import { IAddress } from '@smarttypes/core';
import { get } from 'lodash';

@Pipe({
  name: 'address',
  standalone: true,
})
export class AddressPipe implements PipeTransform {
  transform(value: IAddress, parts: string[] = ['street', 'city', 'stage', 'postalCode', 'country']): string {
    if (!value) {
      return '';
    }
    const address: string[] = [];
    parts.forEach(part => {
      if (get(value, part)) {
        address.push(get(value, part));
      }
    });
    return address.join(', ');
  }
}
